import { Vision, VisionStatus, VisionType } from "./vision";

export class VisionExtensions {
    public constructor(private vision: Vision) { }

    public get isIntegrated() {
        return this.vision.type === VisionType.Integrated;
    }

    public get isPersonal() {
        return this.vision.type === VisionType.Personal;
    }

    public get isCompleted() {
        return this.vision.status === VisionStatus.Completed && this.vision.entityAspect?.entityState.isUnchanged();
    }

    public get isSummary() {
        return !this.vision.visionCategoryId;
    }
}
